export const bookingEventFields = {
  cancel_reason: {
    rules: ['required'],
    label: 'bookings.bookings.choose_reason',
    inputType: 'select',
    options: [
      {
        text: 'bookings.cancel_reasons.overwritten',
        value: 'overwritten',
      },
      {
        text: 'bookings.cancel_reasons.weather',
        value: 'weather',
      },
      {
        text: 'bookings.cancel_reasons.injury',
        value: 'injury',
      },
      {
        text: 'bookings.cancel_reasons.customer',
        value: 'customer',
      },
      {
        text: 'bookings.cancel_reasons.other',
        value: 'other',
      },
    ],
  },
};
